import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProgressProvider } from './contexts/ProgressContext';
import ErrorBoundary from './components/ErrorBoundary';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Resources from './pages/Resources';
import CertificatePage from './pages/CertificatePage';
import MentionsLegales from './pages/MentionsLegales';
import CGV from './pages/CGV';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import Module1 from './pages/modules/Module1';
import Module2 from './pages/modules/Module2';
import Module3 from './pages/modules/Module3';
import Module4 from './pages/modules/Module4';
import Module5 from './pages/modules/Module5';
import Module6 from './pages/modules/Module6';
import ChatGPTTrack from './pages/formations/ChatGPTTrack';
import ClaudeCodeTrack from './pages/formations/ClaudeCodeTrack';
import FusionTrack from './pages/formations/FusionTrack';
import Candidature from './pages/Candidature';
import CandidatureSuccess from './pages/CandidatureSuccess';
import './App.css';

// Pages où la Navbar ne doit PAS s'afficher (pages avec leur propre sidebar)
const pagesWithoutNavbar = [
  '/dashboard',
  '/profile',
  '/settings',
  '/resources',
  '/certificate',
  '/module',
  '/formation'
];

// Pages où le Footer doit s'afficher
const pagesWithFooter = [
  '/',
  '/register',
  '/login',
  '/inscription',
  '/mentions-legales',
  '/cgv',
  '/politique-confidentialite'
];

function AppContent() {
  const location = useLocation();

  // Vérifier si on doit afficher la Navbar
  const showNavbar = !pagesWithoutNavbar.some(page => location.pathname.startsWith(page));

  // Vérifier si on doit afficher le Footer
  const showFooter = pagesWithFooter.includes(location.pathname);

  return (
    <div className="App">
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/inscription" element={<Candidature />} />
        <Route path="/inscription/succes" element={<CandidatureSuccess />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/certificate" element={<CertificatePage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/module/1" element={<Module1 />} />
        <Route path="/module/2" element={<Module2 />} />
        <Route path="/module/3" element={<Module3 />} />
        <Route path="/module/4" element={<Module4 />} />
        <Route path="/module/5" element={<Module5 />} />
        <Route path="/module/6" element={<Module6 />} />
        <Route path="/formation/chatgpt" element={<ChatGPTTrack />} />
        <Route path="/formation/claude" element={<ClaudeCodeTrack />} />
        <Route path="/formation/fusion" element={<FusionTrack />} />
      </Routes>
      {showFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ProgressProvider>
          <Router>
            <AppContent />
          </Router>
        </ProgressProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
